import * as yup from "yup";

export const PhotoGalleryValidation = yup.object().shape({
    sanstha_id: yup.object().required("Required"),
});